import { Component }      from '@angular/core';
import { NavController }  from 'ionic-angular';
import { MenuController } from 'ionic-angular';

@Component({
  selector: 'page-information',
  templateUrl: 'information.html'
})
export class InformationPage
{

  constructor(public navCtrl: NavController,
              public menuCtrl: MenuController){ }

  ionViewDidLoad()
  {

  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/information/information.ts